'use strict';
import {runInjector} from '../../_libs/angular-utils/index';
import {DatePicker} from './components/DatePicker';
import {TimePicker} from './components/TimePicker';
import {DatePickerDirective} from './DatePickerDirective';
import {TimePickerDirective} from './TimePickerDirective';
var angular = require('angular');


module.exports = angular
  .module('app.components.android-date-time-pickers', [])
  .run(runInjector(DatePicker))
  .run(runInjector(TimePicker))

  .directive('datePicker', DatePickerDirective)
  .directive('timePicker', TimePickerDirective)
;



// WEBPACK FOOTER //
// ./src/js/core-components/android-date-time-pickers/index.js